import { IThemeResponse } from '../../../context/theme/custom-theme-context.model';
import httpClient from "../http/http-client";
import {
  IDistributionLossCorrectionJob,
  IDistributionLossCorrectionPreview,
  IDistributionLossCorrectionStart,
  ILedgerCoverageCorrectionJob,
  ILedgerCoverageCorrectionPreview,
  IOrganisationDetails,
  IWttPolicyPreview,
} from './organisation.model';

export default class OrganisationService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getOrganisations(): Promise<IOrganisationDetails[]> {
    return this.http.get('organisation')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }


  async getOne(organisationId: string): Promise<IOrganisationDetails> {
    return this.http.get(`organisation/${organisationId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** What correcting the organisation's open report periods would do. Read-only. */
  async getDistributionLossCorrectionPreview(): Promise<IDistributionLossCorrectionPreview> {
    return this.http.get('organisation/distribution-loss-correction/preview')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** What switching well-to-tank on or off would do to each report period. Read-only. */
  async getWttPolicyPreview(includeWtt: boolean): Promise<IWttPolicyPreview> {
    return this.http.get(`organisation/wtt-policy/preview?includeWtt=${includeWtt ? 'true' : 'false'}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** Queues one background correction job per chosen report period. */
  async startDistributionLossCorrection(reportPeriodIds: string[]): Promise<IDistributionLossCorrectionStart> {
    return this.http.post('organisation/distribution-loss-correction', { reportPeriodIds })
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getDistributionLossCorrectionJobs(jobIds: string[]): Promise<{ jobs: IDistributionLossCorrectionJob[] }> {
    return this.http.get(`organisation/distribution-loss-correction/jobs?ids=${jobIds.join(',')}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** What importing the staged supplier bills would do to each open period. Read-only. */
  async getLedgerCoverageCorrectionPreview(): Promise<ILedgerCoverageCorrectionPreview> {
    return this.http.get('organisation/ledger-coverage-correction/preview')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** Queues one background bill-import job per chosen report period. */
  async startLedgerCoverageCorrection(reportPeriodIds: string[]): Promise<IDistributionLossCorrectionStart> {
    return this.http.post('organisation/ledger-coverage-correction', { reportPeriodIds })
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getLedgerCoverageCorrectionJobs(jobIds: string[]): Promise<{ jobs: ILedgerCoverageCorrectionJob[] }> {
    return this.http.get(`organisation/ledger-coverage-correction/jobs?ids=${jobIds.join(',')}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async editOrganisations(updatedOrganisationDetails: IOrganisationDetails): Promise<IOrganisationDetails> {
    return this.http.patch('organisation/update', updatedOrganisationDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }



  async saveLogo(details: any): Promise<IOrganisationDetails> {
    return this.http.post('organisation/save-logo', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async completeAction(organisationId: string): Promise<IOrganisationDetails> {
    return this.http.post(`organisation/${organisationId}/complete`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async toggleGroupToOrganisation(groupId: string): Promise<any> {
    return this.http.post(`organisation/toggle-group`, { groupId: groupId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOrganisationByCustomDomainUrl(url: string): Promise<IThemeResponse> {
    return this.http.get(`app-styling?url=${url}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async searchOrganisation(searchTerm: string): Promise<any> {
    return this.http.get(`organisation/search?searchTerm=${encodeURIComponent(searchTerm)}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }
}